import React from 'react';

import Spinner from '../components/Spinner';
import cn from '../utils/cn';

const Loading = ({
  className,
}: {
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
}) => (
  <div
    className={cn(
      'h-[250px] w-full flex items-center justify-center opacity-50',
      className
    )}
  >
    <Spinner />
  </div>
);

export default Loading;
